// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oH8K","input":"styles_input__1C6Vm"};